// import { axiosInstance } from "../component/Api/instance";
// import React, { useState, useEffect } from "react";
// import { Modal } from "react-bootstrap";

// import { useNavigate } from "react-router-dom";

// const CountdownTimer = ({ paper, stageId, modelid }) => {
//   const [timeLeft, setTimeLeft] = useState(null);
//   const email = localStorage.getItem("userMail");
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchTimeDifference = async () => {
//       try {
//         const response = await axiosInstance.post(`post/U_ModelMockTest.php`, {
//           id: email,
//           institution_id: modelid,
//           mcq_id: paper,
//           stage_id: stageId,
//         });
//         if (!response || !response.data || !response.data[1]) {
//           console.error("Invalid API response:", response);
//           return;
//         }

//         const serverTime = new Date(response.data[1].test_end);
//         const currentTime = new Date();
//         const timeDifference = Math.floor((serverTime - currentTime) / 1000); // difference in seconds
//         setTimeLeft(timeDifference > 0 ? timeDifference : 0);
//       } catch (error) {
//         console.error("Error fetching time difference:", error);
//       }
//     };

//     fetchTimeDifference();
//   }, [paper, stageId, modelid]);

//   useEffect(() => {
//     if (timeLeft === 0) {
//       setModalIsOpen(true);
//       setTimeout(() => {
//         setModalIsOpen(false);
//         navigate("/model");
//       }, 2000);
//       return;
//     }

//     const timer =
//       timeLeft > 0 &&
//       setInterval(() => {
//         setTimeLeft((prevTime) => prevTime - 1);
//       }, 1000);

//     return () => clearInterval(timer);
//   }, [timeLeft]);

//   const formatTime = (seconds) => {
//     const hrs = Math.floor(seconds / 3600);
//     const mins = Math.floor((seconds % 3600) / 60);
//     const secs = seconds % 60;
//     return `${hrs.toString().padStart(2, "0")}:${mins
//       .toString()
//       .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
//   };

//   return (
//     <div>
//       {timeLeft !== null ? (
//         <p>TIME: {formatTime(timeLeft)}</p>
//       ) : (
//         <p>Loading...</p>
//       )}
//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={() => setModalIsOpen(false)}
//         contentLabel="Times Up!"
//       >
//         <div>
//           <p>Times Up!</p>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default CountdownTimer;
import React, { useEffect, useState } from "react";

function CountdownTimer({ paper, stageId, modelid, paused, duration }) {
  const STORAGE_KEY = `timer_${modelid}_${paper}_${stageId}`;

  // const getInitialTime = () => {
  //   const saved = localStorage.getItem(STORAGE_KEY);
  //   return saved ? parseInt(saved, 10) : 90 * 60; // ⏱️ 1 hour default
  // };

  const [timeLeft, setTimeLeft] = useState(duration ? parseInt(duration * 60, 10) : 90 * 60); // ⏱️ 1.5 hour default

  console.log("duration : ",duration);
  
  useEffect(() => {
    if (paused) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          localStorage.removeItem(STORAGE_KEY);
          return 0;
        }
        localStorage.setItem(STORAGE_KEY, prev - 1);
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [paused]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <h5 style={{ fontWeight: 600 }}>
      {minutes}:{seconds < 10 ? "0" : ""}
      {seconds}
    </h5>
  );
}

export default CountdownTimer;
